import { render, staticRenderFns } from "./TagIndex.vue?vue&type=template&id=d297ac2e&scoped=true"
import script from "./TagIndex.vue?vue&type=script&lang=js"
export * from "./TagIndex.vue?vue&type=script&lang=js"
import style0 from "./TagIndex.vue?vue&type=style&index=0&id=d297ac2e&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d297ac2e",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/www/wwwroot/crm1/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('d297ac2e')) {
      api.createRecord('d297ac2e', component.options)
    } else {
      api.reload('d297ac2e', component.options)
    }
    module.hot.accept("./TagIndex.vue?vue&type=template&id=d297ac2e&scoped=true", function () {
      api.rerender('d297ac2e', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/taskExamine/task/components/Tag/TagIndex.vue"
export default component.exports